<div class="directory-container">
<public-header></public-header>
    
  <div class="not-found-container">
    <h2>Oops! It looks like the page you've landed on is not available.</h2>
      
    <p class="not-found-subtitle">
      SonderMind is a mental health care provider, connecting you with a therapist 
      or psychiatrist who takes your insurance and has availability within a week.
    </p>
    <div class="not-found-button">
      <a href="https://start.sondermind.com" target="_blank" rel="noopener noreferrer">
        <iris-button typeAttribute="button">
          Find care
        </iris-button>
      </a>
    </div>
  </div>

  <div class="list-container">
    <ul>
      <h1>Provider Profile Pages</h1>
      <li *ngFor="let provider of providers">
        <a [href]="[provider.link]">{{ provider.name }}</a>
      </li>
    </ul>
    <button (click)="goToPreviousPage()" [disabled]="currentPage === 1">
      Previous
    </button>
    <button (click)="goToNextPage()" [disabled]="currentPage === totalPages">
      Next
    </button>
  </div>
</div>


<router-outlet></router-outlet>
